module.exports = __webpack_public_path__ + "static/media/cat-modal.5a7a900d.gif";